import {
	Directive,
	ElementRef,
	OnDestroy,
	HostListener,
	OnInit,
	Input,
	OnChanges,
	SimpleChanges,
	HostBinding
} from '@angular/core';

@Directive({
	selector: '[cpClickableElement]'
})
export class ClickableElementDirective implements OnDestroy, OnChanges {
	@Input() elementDescription: string | { id: string }; // Either a string for aria-label or an id of the element to be used in aria-labelledby
	@Input() cpClickableElement: boolean = true; // Can be set to false to stop the directive from being applied using some condition

	@HostBinding("attr.tabindex") tabIndex = 0;
	@HostBinding("attr.aria-label") ariaLabel = null;
	@HostBinding("attr.aria-labelledby") ariaLabelledBy = null;
	@HostBinding("attr.role") @Input() elementRole: string = "button";
	@HostBinding("style.outline-width.px") outlineWidth: number;

	constructor(public elementRef: ElementRef) {

	}

	@HostListener("keypress", ["$event"]) keyPressHandler(event: KeyboardEvent) {
		if (this.cpClickableElement !== false && event.code === "Enter" || event.code === "Space") {
			this.elementRef.nativeElement.click();
		}
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes.cpClickableElement || changes.elementDescription) {
			if (this.cpClickableElement === false) {
				this.elementRole = "";
				this.tabIndex = -1;
				this.outlineWidth = 0;
			} else {
				this.tabIndex = 0;
				this.outlineWidth = 1;

				if (this.elementDescription !== undefined && this.elementDescription !== null) {
					if (typeof this.elementDescription === "string") {
						this.ariaLabel = this.elementDescription;
					} else if (this.elementDescription.id) {
						this.ariaLabelledBy = this.elementDescription.id;
					}
				}
			}
		}
	}

	public ngOnDestroy(): void { }
}
